import { render, staticRenderFns } from "./msgDialog.vue?vue&type=template&id=16e5dbc3&scoped=true&"
import script from "./msgDialog.vue?vue&type=script&lang=js&"
export * from "./msgDialog.vue?vue&type=script&lang=js&"
import style0 from "./msgDialog.vue?vue&type=style&index=0&id=16e5dbc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5dbc3",
  null
  
)

export default component.exports